import React from "react";
import { useTranslation } from "react-i18next";
import "./baltiptsy.css";
import SectionWrapper from "../../components/ComponentWrapper/SectionWrapper";
import BreathingBackground from "../../components/BreathingBackground/BreathingBackground";
import MusicPlayer from "../../components/MusicPlayer/MusicPlayer";

const Baltiptsy = () => {
  const { t } = useTranslation();

  return (
    <BreathingBackground>
    <SectionWrapper>
    <article className="baltiptsy-page">
      {/* HERO */}
      <header className="baltiptsy-hero">
        <h1>{t("baltiptsy.title", "Baltiptsy · El Baile de la Tuza")}</h1>
        <p>
          {t(
            "baltiptsy.subtitle",
            "Obra tradicional de la música mixe interpretada por Kujipy"
          )}
        </p>
      </header>

      {/* SIGNIFICADO */}
      <section className="baltiptsy-section">
        <h2>{t("baltiptsy.meaningTitle", "Significado cultural")}</h2>
        <p>
          {t(
            "baltiptsy.meaningText",
            "Baltiptsy es una pieza musical tradicional que narra la historia de una tuza que come maíz y chayote. La tuza representa la relación entre los seres vivos y la tierra, así como el ciclo del alimento dentro de la comunidad."
          )}
        </p>

        <p>
          {t(
            "baltiptsy.meaningText2",
            "En la tradición mixe, la música no solo se escucha: se baila y se vive colectivamente. El Baile de la Tuza acompaña fiestas y encuentros comunitarios."
          )}
        </p>
      </section>

      {/* EL BAILE */}
      <section className="baltiptsy-section highlight">
        <h2>{t("baltiptsy.danceTitle", "El baile")}</h2>
        <p>
          {t(
            "baltiptsy.danceText",
            "El baile imita de forma simbólica los movimientos de la tuza. Es un baile alegre, repetitivo y colectivo, donde la comunidad participa de manera abierta."
          )}
        </p>

        <p>
          {t(
            "baltiptsy.danceText2",
            "No existe una coreografía rígida: el movimiento surge del ritmo de la banda y de la interacción entre músicos y bailarines."
          )}
        </p>
      </section>

      {/* EN ESCENA */}
      <section className="baltiptsy-section">
        <h2>{t("baltiptsy.liveTitle", "Baltiptsy en escena")}</h2>
        <p>
          {t(
            "baltiptsy.liveText",
            "En presentaciones internacionales, Baltiptsy permite compartir una experiencia cultural viva. El público es invitado a observar, escuchar y, cuando es posible, a participar del baile."
          )}
        </p>
      </section>

      {/* ESCUCHAR */}
      <section className="baltiptsy-section listen">
        <h2>{t("baltiptsy.listenTitle", "Escuchar la obra")}</h2>
        <MusicPlayer compact />
        <div className="listen-links">
          <a
            href="https://open.spotify.com/artist/3tDuuuTkPprgYHtL7QsvXs"
            target="_blank"
            rel="noopener noreferrer"
          >
            Spotify
          </a>
          <a
            href="https://www.youtube.com/@kujipyoficial8421"
            target="_blank"
            rel="noopener noreferrer"
          >
            YouTube
          </a>
        </div>
      </section>

      <div className="epk-inline">
        <p>
          {t("common.workEpk")} <a href="/epk" className="editorial-link">EPK</a>.
        </p>
      </div>

      {/* VOLVER */}
      <footer className="baltiptsy-footer">
        <a href="/music" className="editorial-link">
          ← {t("baltiptsy.back", "Volver a Música")}
        </a>
      </footer>
    </article>
    </SectionWrapper>
    </BreathingBackground>
  );
};

export default Baltiptsy;
